var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-pane-inner"},[_c('div',{staticClass:"inspections-list form-inspection"},[_c('div',{staticClass:"inspection-title"},[_c('span',[_vm._v(" "+_vm._s(`${_vm.inspectionForm.name}`)+" - "+_vm._s(_vm.$t("COMMON.INSPECTIONS"))+" ")])]),_c('inspection-list-table',{attrs:{"filterInspectionForm":_vm.inspectionForm.id}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }